import { render, staticRenderFns } from "./NotebookSnapshotIndicator.vue?vue&type=template&id=01dc5ed7&"
import script from "./NotebookSnapshotIndicator.vue?vue&type=script&lang=js&"
export * from "./NotebookSnapshotIndicator.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports